import type {
  FetchDailyBlotterColumnsDefinitionEpicApi,
  FetchDailyBlotterQuotesEpicApi,
} from 'epic/blotters/dailyBlotter/dailyBlotterEpics';
import { map, timeout } from 'rxjs/operators';
import type {
  DailyBlotterColumns,
  DailyBlotterResponse,
  Filters,
} from 'state/blotters/dailyBlotter/dailyBlotter.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export function dailyBlotterQuotesApiConnector(httpClient: IHttpClient): FetchDailyBlotterQuotesEpicApi {
  const url = 'api/v1/dailyblotter/quotes';

  return {
    fetchDailyBlotterQuotes(pageIndex: number, filters: Filters, itermsPerPage: number) {
      const params = {
        page: pageIndex - 1,
        fullTextSearch: filters.searchedText,
        product: filters.product,
        size: itermsPerPage,
      };

      return httpClient.getJSON<DailyBlotterResponse>({ url, params }).pipe(
        map(response => response.payload),
        timeout(5000),
      );
    },
  };
}

export function dailyBlotterColumunsApiConnector(httpClien: IHttpClient): FetchDailyBlotterColumnsDefinitionEpicApi {
  const url = 'api/v1/blotter/column-definitions/DailyBlotter';

  return {
    fetchDailyBlotterColumns() {
      return httpClien.getJSON<DailyBlotterColumns>({ url }).pipe(
        map(response => response.payload),
        timeout(5000),
      );
    },
  };
}
